/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if
 * you want to be notified when the variant changes on product page, you can
 * attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific
 * product, you can trigger the event "cart:refresh" in a similar way (in that-
 * case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * You can also open or close the cart by triggering the event "cart:open" or
 * "cart:close" This will only open/close the cart and not refresh the contents
 * of the cart but you can chain these events by using async, await, and
 * setTimeout:
 *
 * document.body.dispatchEvent(new CustomEvent('cart:open', {
 *   bubbles: true
 * }));
 *
 * document.body.dispatchEvent(new CustomEvent('cart:close', {
 *   bubbles: true
 * }));
 */

$(document).ready(function () {
  /**
   * --------------------------------------------------------------------------
   * Mobile image slider
   * --------------------------------------------------------------------------
   */
  function responseInitFlickity() {
    var mobile_ImageSlider = document.querySelectorAll(
      '.ProductItem--collection .mobile_ImageSlider'
    );
    if (mobile_ImageSlider.length) {
      var windowWidth = window.innerWidth;
      if (windowWidth < 641) {
        for (var el of mobile_ImageSlider) {
          // Skip Flickity initialization for search results page
          if (el.closest('.template-search')) {
            continue;
          }
          
          var flkty = new Flickity(el, {
            cellAlign: 'left',
            contain: true,
            wrapAround: false,
            prevNextButtons: true,
            dragThreshold: 10,
            pageDots: false,
            arrowShape: {
              x0: 10,
              x1: 45,
              y1: 50,
              x2: 55,
              y2: 50,
              x3: 20,
            },
          });
          flkty.resize();
        }
      }
    }
  }

  // Initial resize.
  responseInitFlickity();

  // Check again for new loaded elements with mobile image slider.
  $(window).on('load', '.mobile_ImageSlider', function () {
    responseInitFlickity();
  });

  const observer = new MutationObserver(function () {
    responseInitFlickity();
  });

  /*
   * Product recommendations use the same snippet for rendering product items.
   * On mobile, product items are using Flickity to display product images as a
   * carousel. Since product recommendations uses AJAX to load content, the
   * product recommendations container needs to be observed to properly resize
   * product items with flickity carousels upon successfully loading the content
   * to avoid stacked images.
   */
  $(document).ready(function () {
    if ($('.ProductRecommendations').length) {
      observer.observe(document.querySelector('.ProductRecommendations'), {
        subtree: false,
        childList: true,
      });
    }
  });

  window.addEventListener('resize', responseInitFlickity);

  /**
   * Initializes flickity on mobile image slider upon loading pagination
   * content on collection pages.
   * @see https://ajaxinate.elkfox.io/
   */
  var endlessScroll = new Ajaxinate({
    container: '#AjaxinateContainer',
    pagination: '#AjaxinatePagination',
    loadingText: 'Loading...',
    method: 'click',
    offset: 1000,
    callback: function () {
      responseInitFlickity();
    },
  });

  const productList = document.querySelector('.CollectionInner__Products');

  if (productList) {
    // Prevent default behavior of pagination links, since Ajaxinate handles this.
    $(document).on('click', '#AjaxinatePagination > a', function (event) {
      event.preventDefault();
    });
  }

  // Reattach event listeners to pagination links after Ajaxinate loads new
  // content. Implemented for when users are changing the filters on collection
  // since products are loaded via AJAX.
  const productListObserver = new MutationObserver(function (event) {
    var endlessScroll = new Ajaxinate({
      container: '#AjaxinateContainer',
      pagination: '#AjaxinatePagination',
      loadingText: 'Loading...',
      method: 'click',
      offset: 1000,
      callback: function () {
        responseInitFlickity();
      },
    });
  });

  try {
    if (productList) {
      productListObserver.observe(
        productList,
        {
          subtree: false,
          childList: true,
        }
      );
    }
    
  } catch (error) {
    console.warn(error);
  }

  /**
   * --------------------------------------------------------------------------
   * Accordions
   * --------------------------------------------------------------------------
   */
  let accordions = document.querySelectorAll('.acco_wrapper .acco_row_title');
  for (let accordion of accordions) {
    accordion.addEventListener('click', function (e) {
      e.preventDefault();

      e.target.classList.toggle('active');
      let container = e.target.nextElementSibling;
      $(container).slideToggle('fast');

      if (!container.classList.contains('active')) {
        container.classList.add('active');
      } else {
        container.classList.remove('active');
      }
    });
  }

  // focus email capture input on "keep in touch" click
  const keepInTouchHeader = document.querySelector('.Footer__NewsletterWrapper > h2');
  const keepInTouchEmailInput = document.querySelector('.Footer__NewsletterWrapper input[type=email]');

  keepInTouchHeader.addEventListener('click', event => {
    if (event.target.textContent.toLowerCase() === 'keep in touch') {
      window.scrollTo({
        top: keepInTouchEmailInput.offsetTop,
        behavior: 'smooth',
      });

      setTimeout(() => keepInTouchEmailInput.focus(), 200);
    }
  });
});


// Sticky Header
const header_el = document.querySelector('#shopify-section-header');
const header_wrapper_el = document.querySelector('.Header__Wrapper');
let pixels_from_top = header_el.getBoundingClientRect().top;

if (pixels_from_top < 0) {
  const store_switcher_el = document.querySelector('#shopify-section-store-switcher');
  const announcement_el = document.querySelector('#shopify-section-announcement');
  // dynamically calculate the pixels from top based on adding the heights of the these two elements
  let store_switcher_margin = parseInt(
    window.getComputedStyle(store_switcher_el).getPropertyValue('margin-bottom')
  );
  let announcement_margin = parseInt(window.getComputedStyle(announcement_el).getPropertyValue('margin-top'));

  pixels_from_top =
    store_switcher_el.offsetHeight + announcement_el.offsetHeight + store_switcher_margin + announcement_margin;
}

window.addEventListener('scroll', function () {
  if (window.pageYOffset >= pixels_from_top) {
    header_el.style.position = 'fixed';
    header_wrapper_el.style.paddingTop = '10px';
    header_wrapper_el.style.paddingBottom = '10px';
    document.body.style.marginTop = header_el.offsetHeight + 'px';
  } else if (window.pageYOffset < pixels_from_top) {
    header_el.style.position = 'relative';
    header_wrapper_el.style.paddingTop = '';
    header_wrapper_el.style.paddingBottom = '';
    document.body.style.marginTop = 0;
  }
});
// END Sticky Header
